import nextId from "react-id-generator"

export const links = [
    {
        id: nextId(),
        url: "#header",
        text: "home"
    },
    {
        id: nextId(),
        url: "#featured",
        text: "feaured"
    },
    {
        id: nextId(),
        url: "#female",
        text: "female"
    },
    {
        id: nextId(),
        url: "#new",
        text: "new"
    },
    {
        id: nextId(),
        url: "#shop",
        text: "shop"
    },
]